export default class LocalStorageUtil {
	public static clear(): void {
		return this._localStorage?.clear();
	}

	public static hasItem(key: string): boolean {
		return this._localStorage?.getItem(key) !== null;
	}

	public static getItem(key: string): string | null {
		return this._localStorage?.getItem(key) ?? null;
	}

	public static getItemAndParse<T>(key: string): T | null {
		const item = this.getItem(key);
		if (item === null) {
			return null;
		} else {
			try {
				const parsed = JSON.parse(item) as T;
				return parsed;
			} catch (err) {
				console.error(err);
				return null;
			}
		}
	}

	public static key(index: number): string | null {
		return this._localStorage?.key(index) ?? null;
	}

	public static removeItem(key: string): void {
		return this._localStorage?.removeItem(key);
	}

	public static setItem(key: string, value: string): void {
		return this._localStorage?.setItem(key, value);
	}

	private static _localStorage: Storage | null =
		typeof window !== 'undefined' && typeof window.localStorage !== 'undefined' ? window.localStorage : null;
}
